import {
  Box, DashboardModuleListItem, Text,
} from '@domain-group/suit-theme'

import type { AssetLibraryModel } from '@models/types'

import useAssetLibrary, { useRelations } from '@hooks/useAssetLibrary'

const AssetLibraryListItem = (props: { assetLibrary: AssetLibraryModel }) => {
  const { assetLibrary } = props
  const {
    attachment_count, title,
  } = assetLibrary

  const assetLibraryPayload = useAssetLibrary(assetLibrary)
  const {
    callbacks: { createOrEditAssetLibrary },
  } = assetLibraryPayload

  const { agency, brand } = useRelations(assetLibrary)

  // @ts-expect-error TS2339
  const ownerTitle = agency?.title || brand?.title

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditAssetLibrary()}
      secondaryText={ownerTitle}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`${attachment_count} Attachment${attachment_count === 1 ? '' : 's'}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default AssetLibraryListItem
